import { useMemo } from 'react';

import { getChannelFromAssetType, getEmailChannelsFromAssetType } from 'src/data/benchmark';
import { getIsEmailChannel } from 'src/data/performance';

import { useChannelAccounts } from './useChannelAccounts';

export const useIsBenchmarkChannelConnected = (assetType) => {
  const { connectedAccounts } = useChannelAccounts();

  return useMemo(() => {
    const channel = getChannelFromAssetType(assetType);
    const isEmailChannel = getIsEmailChannel(channel);
    const emailChannels = getEmailChannelsFromAssetType(assetType);

    const alignedConnectedAccounts = isEmailChannel
      ? emailChannels.flatMap((key) => connectedAccounts?.[key] || [])
      : connectedAccounts?.[channel] || [];

    return alignedConnectedAccounts.length > 0;
  }, [assetType, connectedAccounts]);
};
